"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Calculator Calculate Footer Component
 *
 * Component rendered as "calculate" variant by Calculator Panel Footer
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const CalculatorCalculateFooter = props => {
  const {
      calculateButtonText = "Calculate",
      children,
      className,
      disableDefault = false,
      footerStyles = {},
      handleReset,
      hideCalculate = false,
      hideReset = false,
      onCalculate,
      resetButtonText = "Reset",
      testId
    } = props,
    compositeClasses = (0, _classnames.default)({
      "calculator__panel-actions--isCalculate": true,
      [`${className}`]: className
    });
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compositeClasses,
    "data-testid": testId,
    sx: footerStyles
  }, !hideCalculate && (0, _function.isFunction)(onCalculate) && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "calculator__panel-button calculator__panel-button--isCalculate",
    onClick: onCalculate,
    disabled: disableDefault,
    variant: "primary"
  }, calculateButtonText), !hideReset && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "calculator__panel-button calculator__panel-button--isReset",
    onClick: handleReset,
    variant: "secondary"
  }, resetButtonText), children);
};
CalculatorCalculateFooter.propTypes = {
  /** Calculate button text (Default Value: "Calculate") */
  calculateButtonText: _propTypes.default.string,
  /** Custom child actions fragment/component */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Boolean to deactive default button (Default Value: false) */
  disableDefault: _propTypes.default.bool,
  /** Style object for footer component (Default Value: {}) */
  footerStyles: _propTypes.default.object,
  /* Method to fire on reset */
  handleReset: _propTypes.default.func,
  /** Boolean to hide calculate button (Default Value: false) */
  hideCalculate: _propTypes.default.bool,
  /** Boolean to hide reset button (Default Value: false) */
  hideReset: _propTypes.default.bool,
  /** Calculation method */
  onCalculate: _propTypes.default.func,
  /** Reset button text (Default Value: "Reset") */
  resetButtonText: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};
var _default = exports.default = CalculatorCalculateFooter;